import React from 'react';
import PropTypes from 'prop-types';

import MenuCloseButton from './MenuCloseButton';

import './MapViewsMenu.css';

export function MapViewsMenuComponent({
  mapType,
  mapTypes,
  updateMapType,
  offsetLeft,
  onCloseClick,
}) {
  return (
    <div className="map-toolbar__menu map-toolbar--map" style={{ left: offsetLeft }}>
      <MenuCloseButton onCloseClick={onCloseClick} />
      <div className="toolbox-content filter-box">
        <h4>View Type:</h4>
        <div className="map-toolbar__option">
          <input
            type="radio"
            className="radio--custom"
            id="mapType_road"
            name="mapType"
            value={mapTypes.ROADMAP}
            checked={mapType === mapTypes.ROADMAP || mapType === mapTypes.STREET}
            onChange={updateMapType}
          />
          <label htmlFor="mapType_road">Roads</label>
        </div>
        <div className="map-toolbar__option">
          <input
            type="radio"
            className="radio--custom"
            id="mapType_terrain"
            name="mapType"
            value={mapTypes.TERRAIN}
            checked={mapType === mapTypes.TERRAIN}
            onChange={updateMapType}
          />
          <label htmlFor="mapType_terrain">Terrain</label>
        </div>
        <div className="map-toolbar__option">
          <input
            type="radio"
            className="radio--custom"
            id="mapType_satellite"
            name="mapType"
            value={mapTypes.SATELLITE}
            checked={mapType === mapTypes.SATELLITE}
            onChange={updateMapType}
          />
          <label htmlFor="mapType_satellite">Satellite</label>
        </div>
        <div className="map-toolbar__option">
          <input
            type="radio"
            className="radio--custom"
            id="mapType_hybrid"
            name="mapType"
            value={mapTypes.HYBRID}
            checked={mapType === mapTypes.HYBRID}
            onChange={updateMapType}
          />
          <label htmlFor="mapType_hybrid">Hybrid</label>
        </div>
      </div>
    </div>
  );
}

MapViewsMenuComponent.propTypes = {
  mapType: PropTypes.string.isRequired,
  mapTypes: PropTypes.object.isRequired,
  updateMapType: PropTypes.func.isRequired,
  offsetLeft: PropTypes.number,
  onCloseClick: PropTypes.func.isRequired,
};

export default MapViewsMenuComponent;



// WEBPACK FOOTER //
// ./src/components/MapToolbar/MapViewsMenu.js